// types
import { DefaultConfigProps, MenuOrientation, ThemeDirection, ThemeMode } from 'types/config';

// ==============================|| THEME CONSTANT ||============================== //

/** Where a signed-in admin lands when no `returnTo` is given. */
export const APP_DEFAULT_PATH = '/apps';

export const LOGIN_PATH = '/login';
export const HORIZONTAL_MAX_ITEM = 6;
export const DRAWER_WIDTH = 280;
export const MINI_DRAWER_WIDTH = 90;
export const HEADER_HEIGHT = 74;

/**
 * The Raya desktop client's product id in Hub. The desktop release page starts here; any other client
 * product can be picked from the list of `kind=client` products.
 */
export const DESKTOP_PRODUCT_ID = 'f47b3f7a-2b1c-4a8d-9e6f-5c4d3b2a1f0e';

// ==============================|| THEME CONFIG ||============================== //

const config: DefaultConfigProps = {
  fontFamily: `Inter var`,
  i18n: 'ru',
  menuOrientation: MenuOrientation.VERTICAL,
  menuCaption: true,
  miniDrawer: false,
  container: false,
  mode: ThemeMode.DARK,
  presetColor: 'default',
  themeDirection: ThemeDirection.LTR,
  themeContrast: false
};

export default config;
